// src/Dashboard.js (Admin_dashboard.js)
import React, { useState, useEffect } from "react";
import Axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import Sidebar from "./Sidebar";
import "./Admin_dashboard.css";
import { Host } from "../App";

ChartJS.register(ArcElement, Tooltip, Legend);

const Admin_dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState("");
  const [Postartdate] = useState("2026-01-01");
  const [Poenddate] = useState("2030-01-01");
  const [startdate, setStartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const [postList, setPostList] = useState([]);
  const token = window.localStorage.getItem("acessToken");

  const [totalQtyShipped, setTotalQtyShipped] = useState(0);
  const [Totalraw, setTotalraw] = useState(0);
  const [Totalsupplies, setTotalsupplies] = useState(0);
  const [MonthlySpending, setMonthlySpending] = useState(0);
  const [biweeklyraw, setBiweeklyraw] = useState(0);
  const [biweeklysupplies, setBiweeklysupplies] = useState(0);

  // Error states
  const [errors, setErrors] = useState({
    receivables: false,
    raw: false,
    supplies: false,
    monthly: false
  });

  // Set initial dates
  useEffect(() => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const today = new Date();
    const sdate = new Date(today);
    const edate = new Date(today);
    edate.setDate(edate.getDate() + 14);

    setStartdate(formatDate(sdate));
    setEnddate(formatDate(edate));

    // Set last updated
    const now = new Date();
    setLastUpdated(now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    }));
  }, []);

  // Fetch all data
  useEffect(() => {
    if (!token || !startdate || !enddate) return;

    const fetchAllData = async () => {
      setLoading(true);
      setErrors({
        receivables: false,
        raw: false,
        supplies: false,
        monthly: false
      });

      try {
        // Fetch Total Receivables
        try {
          const receivablesRes = await Axios.get(`https://${Host}/Total_Receivables/${token}`, {
            timeout: 10000
          });
          if (receivablesRes.data) {
            setPostList(receivablesRes.data);
            const totalQty = receivablesRes.data.reduce(
              (acc, val) => acc + (parseFloat(val.Unit_price) || 0) * (parseFloat(val.Remained_parts) || 0),
              0
            );
            setTotalQtyShipped(totalQty);
          }
        } catch (error) {
          console.warn("Error fetching receivables:", error.message);
          setErrors(prev => ({ ...prev, receivables: true }));
        }

        // Fetch Raw Materials
        try {
          const rawRes = await Axios.get(
            `https://${Host}/api/Received_Raw_Material/search/${JSON.stringify({})},${JSON.stringify({})},${Postartdate},${Poenddate},${JSON.stringify({})},1,${token},${JSON.stringify({})}`,
            { timeout: 10000 }
          );
          if (rawRes.data) {
            const totalQty = rawRes.data.reduce(
              (acc, val) => acc + (parseFloat(val.COST) || 0) * (parseFloat(val.Remained_parts) || 0),
              0
            );
            console.log("Total raw materials cost:", totalQty);
            setTotalraw(totalQty);
          }
        } catch (error) {
          console.warn("Error fetching raw materials:", error.message);
          setErrors(prev => ({ ...prev, raw: true }));
        }

        // Fetch Supplies
        try {
          const suppliesRes = await Axios.get(
            `https://${Host}/api/Received_Supplies/search/${JSON.stringify({})},${JSON.stringify({})},${Postartdate},${Poenddate},${JSON.stringify({})},1,${token},${JSON.stringify({})},${JSON.stringify({})}`,
            { timeout: 10000 }
          );
          if (suppliesRes.data) {
            const totalQty2 = suppliesRes.data.reduce(
              (acc, val) => acc + (parseFloat(val.Unit_cost) || 0) * (parseFloat(val.Remained_parts) || 0),
              0
            );
            console.log("Total supplies cost:", totalQty2);
            setTotalsupplies(totalQty2);
          }
        } catch (error) {
          console.warn("Error fetching supplies:", error.message);
          setErrors(prev => ({ ...prev, supplies: true }));
        }

        // Fetch Biweekly Raw Materials
        try {
          if (startdate && enddate) {
            const biweeklyRawRes = await Axios.get(
              `https://${Host}/api/Received_Raw_Material/search/${JSON.stringify({})},${JSON.stringify({})},${startdate},${enddate},${JSON.stringify({})},1,${token},${JSON.stringify({})}`,
              { timeout: 10000 }
            );
            if (biweeklyRawRes.data) {
              const totalQty = biweeklyRawRes.data.reduce(
                (acc, val) => acc + (parseFloat(val.COST) || 0) * (parseFloat(val.Remained_parts) || 0),
                0
              );
              setBiweeklyraw(totalQty);
            }
          }
        } catch (error) {
          console.warn("Error fetching biweekly raw:", error.message);
        }

        // Fetch Biweekly Supplies
        try {
          if (startdate && enddate) {
            const biweeklySuppliesRes = await Axios.get(
              `https://${Host}/api/Received_Supplies/search/${JSON.stringify({})},${JSON.stringify({})},${startdate},${enddate},${JSON.stringify({})},1,${token},${JSON.stringify({})},${JSON.stringify({})}`,
              { timeout: 10000 }
            );
            if (biweeklySuppliesRes.data) {
              const totalQty3 = biweeklySuppliesRes.data.reduce(
                (acc, val) => acc + (parseFloat(val.Unit_cost) || 0) * (parseFloat(val.Remained_parts) || 0),
                0
              );
              setBiweeklysupplies(totalQty3);
            }
          }
        } catch (error) {
          console.warn("Error fetching biweekly supplies:", error.message);
        }

        // Fetch Monthly Spending
        try {
          const monthlyParams = {
            PoNo: "",
            PartNo: "",
            Postartdate,
            Poenddate,
            customer: "",
            order: "",
            section: "",
            token,
            Type: ""
          };

          const monthlyRes = await Axios.get(`https://${Host}/Monthlyspending`, {
            params: monthlyParams,
            timeout: 10000
          });

          if (monthlyRes.data) {
            const monthlyTotal = monthlyRes.data.reduce(
              (acc, val) => acc + (parseFloat(val.Total_Amount) || 0),
              0
            );
            setMonthlySpending(monthlyTotal);
          }
        } catch (error) {
          console.warn("Error fetching monthly spending:", error.message);
          setErrors(prev => ({ ...prev, monthly: true }));
        }

        // Update timestamp
        const now = new Date();
        setLastUpdated(now.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        }));

      } catch (error) {
        console.error("Error in fetchAllData:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [token, startdate, enddate, Postartdate, Poenddate]);

  // Calculate totals
  const totalReceivables = parseFloat(totalQtyShipped) || 0;
  const totalPayables = (parseFloat(Totalraw) || 0) + (parseFloat(Totalsupplies) || 0);
  const netCashFlow = totalReceivables - totalPayables;

  // Chart data
  const doughnutData = {
    labels: ["Receivables", "Payables"],
    datasets: [
      {
        data: [totalReceivables, totalPayables],
        backgroundColor: ["#10b981", "#3b82f6"],
        hoverBackgroundColor: ["#0ea271", "#2563eb"],
        borderWidth: 2,
        borderColor: "#ffffff",
        hoverBorderWidth: 3
      }
    ]
  };

  const doughnutOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "rgba(15, 23, 42, 0.95)",
        titleColor: "#f8fafc",
        bodyColor: "#f8fafc",
        borderColor: "#334155",
        borderWidth: 1,
        cornerRadius: 8,
        callbacks: {
          label: (context) => {
            const label = context.label || '';
            const value = context.raw || 0;
            return `${label}: $${formatCurrency(value)}`;
          }
        }
      }
    }
  };

  // Formatting helpers
  const formatCurrency = (value) => {
    const num = parseFloat(value) || 0;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(num);
  };

  const formatCompactCurrency = (value) => {
    const num = parseFloat(value) || 0;
    if (num >= 1000000) {
      return `$${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `$${(num / 1000).toFixed(1)}K`;
    }
    return formatCurrency(num);
  };

  const getCurrentMonthName = () => {
    return new Date().toLocaleString('default', { month: 'long' });
  };

  const handleRefresh = () => {
    const now = new Date();
    setLastUpdated(now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    }));

    // Re-fetch data by updating a state to trigger useEffect
    setStartdate(prev => prev); // This will trigger the useEffect
  };

  // Error display component
  const ErrorBadge = ({ type }) => {
    if (!errors[type]) return null;

    const errorMessages = {
      receivables: "Receivables data unavailable",
      raw: "Raw materials data unavailable",
      supplies: "Supplies data unavailable",
      monthly: "Monthly spending data unavailable"
    };

    return (
      <span className="error-badge" title={errorMessages[type]}>⚠️</span>
    );
  };

  return (
    <div className="dashboard">
      {/* Header */}
      <header className="dashboard-header">
        <div className="header-content">
          <div className="header-title">
            <h1>Financial Dashboard</h1>
            <p className="header-subtitle">Real-time overview of cash flow and liabilities</p>
          </div>
          <div className="header-actions">
            <div className="last-updated">
              <span className="clock-icon">🕒</span>
              <span>Updated: {lastUpdated || "Loading..."}</span>
            </div>
            <button
              className="refresh-btn"
              onClick={handleRefresh}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinning">⟳</span>
                  Refreshing...
                </>
              ) : (
                <>
                  <span>↻</span>
                  Refresh Data
                </>
              )}
            </button>
          </div>
        </div>
      </header>

      <div className="dashboard-layout">
        <aside className="dashboard-sidebar" id="Admin-sidebar">
          <Sidebar />
        </aside>

        <main className="dashboard-main">
          {/* KPI Cards */}
          <div className="kpi-grid">
            <div className="kpi-card">
              <div className="kpi-header">
                <div className="kpi-icon" style={{ backgroundColor: 'rgba(16, 185, 129, 0.1)' }}>
                  <span style={{ color: '#10b981', fontSize: '24px' }}>💰</span>
                </div>
                <div className="kpi-trend">
                  <span style={{ fontSize: '16px' }}>📈</span>
                  <span>Receivables</span>
                  <ErrorBadge type="receivables" />
                </div>
              </div>
              <div className="kpi-content">
                <h3 className="kpi-value">
                  {loading ? '...' : formatCompactCurrency(totalReceivables)}
                </h3>
                <p className="kpi-label">Total Outstanding Payments</p>
              </div>
              <div className="kpi-footer">
                <span className="kpi-hint">
                  <span style={{ fontSize: '12px' }}>📦</span>
                  {postList.length || 0} Active Orders
                </span>
              </div>
            </div>

            <div className="kpi-card">
              <div className="kpi-header">
                <div className="kpi-icon" style={{ backgroundColor: 'rgba(59, 130, 246, 0.1)' }}>
                  <span style={{ color: '#3b82f6', fontSize: '24px' }}>💳</span>
                </div>
                <div className="kpi-trend">
                  <span style={{ fontSize: '16px' }}>📉</span>
                  <span>Payables</span>
                  <ErrorBadge type="raw" />
                  <ErrorBadge type="supplies" />
                </div>
              </div>
              <div className="kpi-content">
                <h3 className="kpi-value">
                  {loading ? '...' : formatCompactCurrency(totalPayables)}
                </h3>
                <p className="kpi-label">
                  Raw: {formatCompactCurrency(Totalraw)} •
                  Supplies: {formatCompactCurrency(Totalsupplies)}
                </p>
              </div>
              <div className="kpi-footer">
                <span className="kpi-hint">
                  <span style={{ fontSize: '12px' }}>⚠️</span>
                  Total Outstanding Bills
                </span>
              </div>
            </div>

            <div className="kpi-card">
              <div className="kpi-header">
                <div className="kpi-icon" style={{ backgroundColor: 'rgba(139, 92, 246, 0.1)' }}>
                  <span style={{ color: '#8b5cf6', fontSize: '24px' }}>📅</span>
                </div>
                <div className="kpi-trend">
                  <span>Monthly</span>
                  <ErrorBadge type="monthly" />
                </div>
              </div>
              <div className="kpi-content">
                <h3 className="kpi-value">
                  {loading ? '...' : formatCompactCurrency(MonthlySpending)}
                </h3>
                <p className="kpi-label">{getCurrentMonthName()} Expenditure</p>
              </div>
              <div className="kpi-footer">
                <span className="kpi-hint">
                  {Postartdate} to {Poenddate}
                </span>
              </div>
            </div>

            <div className={`kpi-card net-flow ${netCashFlow >= 0 ? 'positive' : 'negative'}`}>
              <div className="kpi-header">
                <div className="kpi-icon" style={{
                  backgroundColor: netCashFlow >= 0 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)'
                }}>
                  <span style={{
                    color: netCashFlow >= 0 ? '#22c55e' : '#ef4444',
                    fontSize: '24px'
                  }}>
                    {netCashFlow >= 0 ? '📈' : '📉'}
                  </span>
                </div>
                <div className="kpi-trend">
                  <span>Net Flow</span>
                </div>
              </div>
              <div className="kpi-content">
                <h3 className="kpi-value">
                  {formatCompactCurrency(Math.abs(netCashFlow))}
                  <span className="flow-direction">
                    {netCashFlow >= 0 ? ' Surplus' : ' Deficit'}
                  </span>
                </h3>
                <p className="kpi-label">Receivables - Payables</p>
              </div>
              <div className="kpi-footer">
                <span className="kpi-hint">
                  {netCashFlow >= 0 ? '💰 Positive Cash Flow' : '📉 Negative Cash Flow'}
                </span>
              </div>
            </div>
          </div>

          {/* Chart and Biweekly Cards */}
          <div className="content-grid">
            <div className="chart-container">
              <div className="chart-header">
                <h3>Financial Distribution</h3>
                <p className="chart-subtitle">Receivables vs Payables Ratio</p>
              </div>
              <div className="chart-wrapper">
                {totalReceivables + totalPayables > 0 ? (
                  <>
                    <div className="chart-visualization">
                      <Doughnut data={doughnutData} options={doughnutOptions} />
                    </div>
                    <div className="chart-legend">
                      <div className="legend-item">
                        <div className="legend-color" style={{ backgroundColor: '#10b981' }}></div>
                        <div className="legend-info">
                          <span className="legend-label">Receivables</span>
                          <span className="legend-value">{formatCurrency(totalReceivables)}</span>
                        </div>
                      </div>
                      <div className="legend-item">
                        <div className="legend-color" style={{ backgroundColor: '#3b82f6' }}></div>
                        <div className="legend-info">
                          <span className="legend-label">Payables</span>
                          <span className="legend-value">{formatCurrency(totalPayables)}</span>
                        </div>
                      </div>
                      <div className="legend-item total">
                        <div className="legend-info">
                          <span className="legend-label">Total Exposure</span>
                          <span className="legend-value">{formatCurrency(totalReceivables + totalPayables)}</span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="no-data-message">
                    <div className="no-data-icon">📊</div>
                    <h4>No Financial Data Available</h4>
                    <p>Waiting for data to load...</p>
                  </div>
                )}
              </div>
            </div>

            <div className="biweekly-container">
              <div className="section-header">
                <h3>Biweekly Outlook</h3>
                <p className="section-subtitle">Next 14 Days Forecast</p>
              </div>
              <div className="biweekly-cards">
                <div className="biweekly-card">
                  <div className="biweekly-header">
                    <span style={{ fontSize: '18px' }}>🕒</span>
                    <span className="card-period">{startdate} - {enddate}</span>
                  </div>
                  <div className="biweekly-content">
                    <h4 className="biweekly-title">Incoming Receivables</h4>
                    <div className="biweekly-value">{formatCompactCurrency(biweeklyraw)}</div>
                    <div className="biweekly-progress">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${totalReceivables > 0 ? Math.min((biweeklyraw / totalReceivables) * 100, 100) : 0}%`,
                          backgroundColor: '#10b981'
                        }}
                      ></div>
                    </div>
                    <p className="biweekly-hint">
                      {totalReceivables > 0
                        ? `${Math.round((biweeklyraw / totalReceivables) * 100)}% of total receivables`
                        : 'No receivables data'
                      }
                    </p>
                  </div>
                </div>

                <div className="biweekly-card">
                  <div className="biweekly-header">
                    <span style={{ fontSize: '18px' }}>🕒</span>
                    <span className="card-period">{startdate} - {enddate}</span>
                  </div>
                  <div className="biweekly-content">
                    <h4 className="biweekly-title">Upcoming Payables</h4>
                    <div className="biweekly-value">{formatCompactCurrency(biweeklysupplies)}</div>
                    <div className="biweekly-progress">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${totalPayables > 0 ? Math.min((biweeklysupplies / totalPayables) * 100, 100) : 0}%`,
                          backgroundColor: '#3b82f6'
                        }}
                      ></div>
                    </div>
                    <p className="biweekly-hint">
                      {totalPayables > 0
                        ? `${Math.round((biweeklysupplies / totalPayables) * 100)}% of total payables`
                        : 'No payables data'
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Admin_dashboard;